<div class="card-system" *ngIf="gallery$ | async as images">
  <div class="card-system__background">
    <img class="card-system__img2" loading="lazy" src="assets/images/clip.png" [alt]="'global.image' | translate" />
    <img class="card-system__img3" loading="lazy" src="assets/images/giz.png" [alt]="'global.image' | translate" />
    <img class="card-system__img4" loading="lazy" src="assets/images/planta.png" [alt]="'global.image' | translate" />
    <!-- <img class="card-system__img5" loading="lazy" [src]="images[gallery.Books]" [alt]="'global.image' | translate" /> -->
  </div>

  <div class="card-system__group">
    <h1 class="card-system__title">{{ 'teaching-system.title' | translate }}</h1>
    <div class="card-system__text" [innerHtml]="'teaching-system.description' | translate"></div>
    <!-- <img class="card-system__img1" loading="lazy" [src]="images[gallery.Student3]" [alt]="'global.image' | translate" /> -->
  </div>
</div>
